/**
 * The absolute URL of the manage page for a booking made in this widget. The widget has no setting for
 * its own public URL, and an island runs on the storefront's origin, so the origin comes from where this
 * module was loaded (book.<domain> in all three mounts). A non-http(s) module URL (a test runner's
 * `file:`) falls back to the page's origin.
 */
export function manageLink(venueId: string, token: string, moduleUrl = import.meta.url): string {
  return `${widgetOrigin(moduleUrl)}/m/${encodeURIComponent(venueId)}/${encodeURIComponent(token)}`;
}

function widgetOrigin(moduleUrl: string): string {
  const { protocol, origin } = new URL(moduleUrl);
  return protocol === "http:" || protocol === "https:" ? origin : window.location.origin;
}
